import { Image, PageWidget } from 'app/src/shared/components'
import { AppBarPaths, CatalogPath, useWebAppContext, useWelfarePortalNavigate } from 'app/src/shared/hooks'
import { useLocation } from 'react-router-dom'

export function BrandBar() {
  const context = useWebAppContext()
  const location = useLocation()
  const navigate = useWelfarePortalNavigate()

  return (
    (!navigate.isActivePath(AppBarPaths.Catalog, location.pathname) || location.pathname === CatalogPath) && (
      <PageWidget childrenDefaultClassNames='p-2' containerClassNamesOverrides='bg-[var(--logo-section-background)]'>
        <div className='grid grid-cols-1 lg:grid-cols-5'>
          {context.userInfo.welfareCampaign?.configuration?.frontend?.companyLogoPath && (
            <Image
              alt="Logo dell'azienda"
              src={context.userInfo.welfareCampaign.configuration.frontend.companyLogoPath}
              pt={{
                root: { className: 'col-start-1 lg:col-start-3' },
                image: { className: 'object-fit mx-auto max-w-[200px] max-h-[100px]' },
              }}
            />
          )}
        </div>
      </PageWidget>
    )
  )
}
